module.exports = __webpack_public_path__ + "img/female-figure-standing.dd51fe6d.svg";